/*--------------------------------------------------------------------------*
 * 検索条件削除
 *--------------------------------------------------------------------------*/
module Module_Delete {
	export class Model_Delete {
		resetInput(mdl: JQuery): void {
			const modalBody = mdl.find('.c-mdl__body').not('[aria-hidden="true"]'),
				inputs: JQuery = modalBody.find('input'),
				select: JQuery = modalBody.find('select')
			inputs.each(function(): void {
				const _self = $(this)
				switch(_self.attr('type')) {
					case 'checkbox':
					case 'radio':
						_self.prop('checked', false)
						break
					case 'text':
						_self.val('')
						break
				}
			})

			select.val('')
		}
	}
}
